import React, { useState } from 'react'
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  makeStyles
} from '@material-ui/core'
import {
  BASE_COLORS,
  ERROR_COLORS,
  GRAY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import moment from 'moment/moment'
import { Modal, ModalTitle } from 'asterX-UI/Modals'
import { FieldInfoNG } from 'asterX-UI/DataDisplay'
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  title: {
    color: GRAY_COLORS[800],
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  bankBlock: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 12,
    backgroundColor: BASE_COLORS.White,
    gap: 9,
    padding: 16
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  centredRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  bankName: {
    color: GRAY_COLORS[700],
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px'
  },
  chipRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  subText: {
    color: GRAY_COLORS[500],
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px'
  },
  managerText: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    color: GRAY_COLORS[700]
  }
}))
const CreditRequestsCard = ({ creditRequest }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {`${creditRequest.clientFirstname}  ${creditRequest.clientLastname}`}
      </div>

      <div className={classes.bankBlock}>
        {creditRequest?.banks?.map((bank, index) => (
          <BankCard
            bank={bank}
            client={{
              fio: `${creditRequest?.clientLastname || ''} ${
                creditRequest?.clientFirstname || ''
              } ${creditRequest?.clientPatronymic || ''}`,
              iin: creditRequest?.clientIIN || '-'
            }}
            isLast={index === creditRequest?.banks?.length - 1}
          />
        ))}
      </div>
    </div>
  )
}

export default CreditRequestsCard

const BankCard = ({ bank, isLast, client }) => {
  const classes = useStyles()
  const colors = bank?.approved ? SUCCESS_COLORS : ERROR_COLORS
  const [open, setOpen] = useState(false)
  const onOpen = () => setOpen(!open)
  return (
    <>
      <div
        onClick={onOpen}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 9
        }}
      >
        <div className={classes.row}>
          <div className={classes.bankName}>{bank?.name}</div>
          <div className={classes.chipRow}>
            <ChipStandard
              color={WARNING_COLORS[300]}
              backgroundColor={WARNING_COLORS[25]}
            >
              {bank?.alternative && 'Альтернатива'}
            </ChipStandard>
            <ChipStandard color={colors[700]} backgroundColor={colors[50]}>
              {bank?.approved ? 'Одобрено' : 'Отказано'}
            </ChipStandard>
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.subText}>{bank?.branch}</div>
          <div className={classes.subText}>
            {bank?.date ? moment(bank?.date).format('DD MMM YYYY') : '-'}
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.managerText}>{bank?.manager}</div>
        </div>
        {!isLast && (
          <Divider
            style={{
              marginTop: 12,
              marginBottom: 12
            }}
          />
        )}
      </div>
      <Modal open={open} onClose={onOpen} fullWidth>
        <ModalTitle onClose={onOpen}>Офлайн кредит</ModalTitle>
        <DialogContent>
          <div className={classes.root}>
            <div className={classes.row}>
              <div className={classes.bankName}>{bank?.name}</div>
              <ChipStandard color={colors[700]} backgroundColor={colors[50]}>
                {bank?.approved ? 'Одобрено' : 'Отказано'}
              </ChipStandard>
            </div>
            <FieldInfoNG label={'ФИО'} isVertical>
              {client?.fio}
            </FieldInfoNG>
            <div className={classes.row}>
              <FieldInfoNG
                label={'ИИН'}
                isVertical
                rootStyle={{
                  width: '40%'
                }}
              >
                {client?.iin}
              </FieldInfoNG>
              <FieldInfoNG
                label={'Дата заявки'}
                isVertical
                rootStyle={{
                  width: '40%'
                }}
              >
                {bank?.date ? moment(bank?.date).format('DD MMM YYYY') : '-'}
              </FieldInfoNG>
            </div>{' '}
            <div className={classes.row}>
              <FieldInfoNG
                label={'Срок кредита'}
                isVertical
                rootStyle={{
                  width: '40%'
                }}
              >
                {bank?.creditTerm || '-'}
              </FieldInfoNG>
              <FieldInfoNG
                label={'ПВ'}
                isVertical
                rootStyle={{
                  width: '40%'
                }}
              >
                {bank?.downPaymentAmount?.toString()?.thousandSeparator() ||
                  '-'}
              </FieldInfoNG>
            </div>
            <FieldInfoNG label={'Сумма займа'} isVertical>
              {bank?.creditAmount?.toString()?.thousandSeparator() || '-'}
            </FieldInfoNG>
            {!!bank?.decisionDescription && (
              <FieldInfoNG label={''} isVertical>
                {bank?.decisionDescription}
              </FieldInfoNG>
            )}
            <div className={classes.centredRow}>
              <span
                style={{
                  color: GRAY_COLORS[400],
                  fontSize: '14px',
                  fontWeight: 400
                }}
              >
                {' '}
                Авто отсутствует
              </span>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            fullWidth
            variant={'contained'}
            color={'primary'}
            onClick={onOpen}
          >
            Закрыть
          </Button>
        </DialogActions>
      </Modal>
    </>
  )
}
